import { z } from 'zod';

// =============================================================================
// Audit Field Change
// =============================================================================

/** A single field-level change within an audit entry. */
export const auditFieldChangeSchema = z.object({
  field: z.string(),
  before: z.unknown().nullable(),
  after: z.unknown().nullable(),
});

export type AuditFieldChange = z.infer<typeof auditFieldChangeSchema>;

// =============================================================================
// Audit Log Entry
// =============================================================================

/** Response schema for a single audit log entry. */
export const auditLogEntrySchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid().nullable(),
  userName: z.string().nullable(),
  action: z.string(),
  objectType: z.string(),
  objectId: z.string().uuid(),
  changes: z.array(auditFieldChangeSchema).nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  createdAt: z.string(),
});

export type AuditLogEntry = z.infer<typeof auditLogEntrySchema>;

// =============================================================================
// Query & Response
// =============================================================================

/** Query params for fetching audit logs for a specific object. */
export const auditLogQuerySchema = z.object({
  objectType: z.string(),
  objectId: z.string().uuid(),
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(50),
});

export type AuditLogQuery = z.infer<typeof auditLogQuerySchema>;

/** Paginated audit log response. */
export const auditLogResponseSchema = z.object({
  data: z.array(auditLogEntrySchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
});

export type AuditLogResponse = z.infer<typeof auditLogResponseSchema>;
